module.exports = __webpack_public_path__ + "static/og_boredom-52f9055e3b90e68f0f2c5bf7a637ffe6.jpg";